/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAssessmentFrameworkRun extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAssessmentFrameworkRun");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAssessmentFrameworkRun.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAssessmentFrameworkRun>): BackgroundJobPayloadForAssessmentFrameworkRun {
        let obj = Object.assign(new BackgroundJobPayloadForAssessmentFrameworkRun(), model);
        BackgroundJobPayloadForAssessmentFrameworkRun.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAssessmentFrameworkRun>): BackgroundJobPayloadForAssessmentFrameworkRun {
        if (!model) return null;
        return BackgroundJobPayloadForAssessmentFrameworkRun.newInstance(<BackgroundJobPayloadForAssessmentFrameworkRun> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAssessmentFrameworkRun) {
        if (!obj) return;

        models.BackgroundJobPayloadForAssessmentFrameworkRun.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAssessmentFrameworkRun): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAssessmentFrameworkRun.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.assessment_run_details) {
            models.AssessmentRetriggerState.fixupPrototype(this.assessment_run_details);
        }
    }

    /**
     * Service account for which the assessments have to be triggered
     */
    service_account_id: string;

    /**
     * Name of the categories for which the assessment has to be triggered
     */
    category_list: Array<models.AssessmentCategory>;

    /**
     * assessment is triggered by automation or manual mode
     */
    assessment_mode: models.AssessmentMode;

    /**
     * assessment triggered by user or system
     */
    triggered_by: string;

    /**
     * user id
     */
    user_id: string;

    /**
     * assessment run related details
     */
    assessment_run_details: models.AssessmentRetriggerState;

}
